module.exports = __webpack_public_path__ + "img/zhengshu.325e4e6a.png";